// extracted by mini-css-extract-plugin
export default {"title":"grdDB","title--isCentered":"_8t3fi","skeleton-progress":"k7EXk"};